<template>
    <div class="container">
        <a-config-provider :locale="currentLocale">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <span>Vistorias</span>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>Listar</a-breadcrumb-item>
                    </a-breadcrumb>
                </template>
                <template #extra>
                    <a-button :icon="h(PlusOutlined)">Nova Vistoria</a-button>
                    <a-button href="/download-apk" phaceholder="Aplicativo de coleta de campo">Download Aplicativo</a-button>
                </template>
                <a-table :columns="columns" :data-source="dataSource" bordered>
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.dataIndex === 'data'">
                            {{new Date(record.data).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}}
                        </template>
                        <template v-if="column.key === 'acao'">
                            <a-button type="primary" shape="circle" @click="vistoriar(record);">
                                <template #icon>
                                    <a-tooltip>
                                        <template #title>Vistoriar</template>
                                        <FormOutlined />
                                    </a-tooltip>
                                </template>
                            </a-button>
                        </template>
                    </template>
                </a-table>
            </a-card>
        </a-config-provider>
    </div>
</template>

<script setup>
import { ref, h, onMounted } from 'vue';
import { PlusOutlined, FormOutlined} from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';

const dataSource = ref();
const currentLocale = ref(ptBR);

const columns = ref(
    [
        {
            title: 'Vistoria',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 150,
        },

        {
            title: 'Matricula',
            dataIndex: 'matricula',
            key: 'matricula',
            width: 150,
            sorter: {
                compare: (a, b) => a.matricula - b.matricula,
            },
        },
        {
            title: 'Data',
            dataIndex: 'data',
            key: 'data',
            width: 150,
            sorter: (a, b) => {
                return new Date(a.data).getTime() - new Date(b.data).getTime();
            }
        },
        {
            title: 'Observacoes',
            dataIndex: 'observacoes',
            key: 'observacoes',
            width: 650,
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ]
);

onMounted(async () => {
    try {
        const response = await window.axios.get('vistorias/listar');
        console.log(response.data);
        dataSource.value = response.data.vistorias;
    } catch (error) {

    }
});


const vistoriar = (data) => {
    window.location.href = `/vistorias/${data.matricula}/${data.data}`;
}

</script>

<style scoped>
.anticon {
    vertical-align: 0 !important;
}
.ant-table-thead{
    background-color: blue;
}
</style>

